Vendd.Scripts.load(function () {

    $('.x-control.x-box.x-article-review-box[data-control="box"][data-type="review"]').each(function(i, wrapper) {

        var $box = $(wrapper);

        var reviewId = $box.data('reviewid');
        var sessionIsAuthenticated = $box.data('session-is-authenticated');
        if ($box.find('> input[type="hidden"][data-member="isauthenticated"]').length > 0)
            sessionIsAuthenticated = $box.find('> input[type="hidden"][data-member="isauthenticated"]').val() === 'true';

        var currentUserVotedForHelpfullness = $box.data('current-user-voted-for-helpfullness');
        if ($box.find('> input[type="hidden"][data-member="helpfullness"]').length > 0)
            currentUserVotedForHelpfullness = $box.find('> input[type="hidden"][data-member="helpfullness"]').val() === 'true';

        var $loginPopup = $('div[data-type="helpfullness-login-popup"]', $box);
        if ($loginPopup.length == 0) throw new Error("login popUp does not exist on article review box");

        var $btnVoteYes = $box.find('*:enabled[data-click="vote-yes"]');
        var $voteYesInputWrapper = $btnVoteYes.parent();

        var $btnVoteNo = $box.find('*:enabled[data-click="vote-no"]');
        var $voteNoInputWrapper = $btnVoteNo.parent();

        var $totalYesVotes = $box.find('*[data-input="helpfullness-yes-total"]');
        var $totalNoVotes = $box.find('*[data-input="helpfullness-no-total"]');

        var $userVotedMessage = $box.find('.user-voted');
        var $voteError = $box.find('.vote-msg-error');

        function yesVoteSuccess (response) {
            if (response.success) {
                $totalYesVotes.val(parseInt($totalYesVotes.val()) + 1);
                $btnVoteYes.prop('disabled', true);
                $voteYesInputWrapper.addClass('x-disabled');
                $btnVoteNo.prop('disabled', true);
                $voteNoInputWrapper.addClass('x-disabled');
                $userVotedMessage.show();

            } else {
                $voteError.html(LhApp.Function.getText('Validation:' + response.code));
                $voteError.show();
            };
        };

        function noVoteSuccess (response) {
            if (response.success) {
                $totalNoVotes.val(parseInt($totalNoVotes.val()) + 1);
                $btnVoteYes.prop('disabled', true);
                $voteYesInputWrapper.addClass('x-disabled');
                $btnVoteNo.prop('disabled', true);
                $voteNoInputWrapper.addClass('x-disabled');
                $userVotedMessage.show();

            } else {
                $voteError.html(LhApp.Function.getText('Validation:' + response.code));
                $voteError.show();
            };
        };

        function voteFailure (response) {
            $voteError.html(LhApp.Function.getText('Validation:' + response.code));
            $voteError.show();
        };



        $btnVoteYes.click(function (e) {
            if (sessionIsAuthenticated) {
                if (!currentUserVotedForHelpfullness) {

                    $voteError.hide();

                    Vendd.MessageBus.publishAsync(wrapper, new Vendd.Article.Messages.ReviewVote(reviewId, true));
                };
            } else {
                $loginPopup.show();
            };
        });

        $btnVoteNo.click(function (e) {
            if (sessionIsAuthenticated) {
                if (!currentUserVotedForHelpfullness) {

                    $voteError.hide();

                    Vendd.MessageBus.publishAsync(wrapper, new Vendd.Article.Messages.ReviewVote(reviewId, false));
                };
            } else {
                $loginPopup.show();
            };
        });

        if (!sessionIsAuthenticated) {

            var $loginLink = $('*[data-click="login"]', $loginPopup);
            var $registerLink = $('*[data-click="register"]', $loginPopup);
            var $closeBtn = $('*[data-click="close-popup"]', $loginPopup);

            var $loginWidget = $('.x-control.x-widget.x-login-widget[data-control="login"][data-type="widget"]').first();

            var redirectUrl = document.location.href + "&mode=view-reviews";

            $loginLink.click(function(e) {
                $loginPopup.hide();

                if ($loginWidget.length > 0 && $loginWidget.data('expandable') == true) {

                    var $loginForm = $('.x-login-form', $loginWidget);

                    $loginForm.data('redirect', redirectUrl);

                    $('html, body').animate({ scrollTop: $loginWidget.offset().top }, 1500);
                    LhApp.pauseScroll = true;
                    setTimeout(function() { LhApp.pauseScroll = false; }, 2000);
                    $loginWidget.get(0).expand();
                    e.stopPropagation();

                } else {
                    document.location = LhApp.Function.Url.setParameterValueOnUrl(LhApp.Url.Page.Login, 'ReturnUrl', encodeURIComponent(redirectUrl));
                }
            });

            $registerLink.click(function(e) {

                document.location = LhApp.Function.Url.setParameterValueOnUrl(LhApp.Url.Page.Register, 'ReturnUrl', encodeURIComponent(redirectUrl));
            });

            $closeBtn.click(function (e) {
                $loginPopup.hide();
            });
        } else {
            $loginPopup.remove();
        }

        Vendd.MessageBus.subscribe(Vendd.Article.Messages.ReviewVoteSuccess, wrapper, function (envelope) {
            if (envelope.message.data.vote === true) {
                yesVoteSuccess(envelope.message.data.response)
            } else {
                noVoteSuccess(envelope.message.data.response)
            };
        });

        Vendd.MessageBus.subscribe(Vendd.Article.Messages.ReviewVoteFailure, wrapper, function (envelope) {
            voteFailure(envelope.message.data.response);
        });
    });
});